import { newAPI } from "../newAxios";

export const addRoleAPI = async (payload) => {
  const res = await newAPI.post("/role", payload);
  return res.data;
};

export const updateRoleAPI = async (id, payload) => {
  const res = await newAPI.put(`/role/${id}`, payload);
  return res.data;
};

export const deleteRoleAPI = async (id) => {
  const res = await newAPI.delete(`/role/${id}`);
  return res.data;
};

export const getRolesData = async (data) => {
  const res = await newAPI.post("/role/all", data);
  return res.data;
};

export const getRolesDataDropdown = async (data) => {
  const res = await newAPI.get("/role/drop-down", data);
  return res.data;
};

export const getRoleById = async (id) => {
  const res = await newAPI.get(`/role/${id}`);
  return res.data;
};

export const getAllPermission = async ()=> {
  const res = await newAPI.get('/permission');
  return res.data.data;
}

export const getRoleAssignedPermissions = async (roleId) => {
  const res = await newAPI.get(`/role-access/role-id/${roleId}`);
  return res.data;
};

export const updateRolePermissionsAPI = async (payload) => {
  const res = await newAPI.put("/role-access", payload);
  return res.data;
};

export const getAllReportingData = async () => {
  const res = await newAPI.post('/user/drop-down/report-manager', {permission: 'leave.approve'});
  return res.data;
}

export const getAllReportingData2 = async (payload) => {
  const res = await newAPI.get('/reporting2');
  return res.data;
}

export const submitReportApi = async (payload) => {
  const res = await newAPI.post('/employee/update/manager', payload);
  return res.data;
};
